import React from "react";
import {Link} from "react-router-dom";
import './Sidebar.css'
import logo from "../logo.svg";

interface Props {

}

export default class Sidebar extends React.Component<Props, any> {
    controllSideBar() {
        let el = document.getElementById("sidebar-0");
        if (el === null) return;
        if (el.classList.contains("collapsed")) {
            el.classList.remove("collapsed")
        } else {
            el.classList.add("collapsed")
        }
    }

    state = {
        "data": [
            {
                "title": "Наука",
                "data": [{
                    "link": "",
                    "text": ""
                }]
            },
            {
                "title": "",
                "link": ""
            },
        ]
    }

    async componentDidMount(): Promise<void> {
        const response = await fetch(`${process.env.PUBLIC_URL}/configs/Navigation.json`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const dataURL = await response.json();
        this.setState({
            data: dataURL,
        });
    }

    render() {
        return <>
            <div className="position-fixed end-0 c-style top-0 sidebar bg-sidebar-1 sidebar-ground collapsed z-3"
                 id="sidebar-0">
                <header className="w-100 border-bottom border-3 border-secondary sticky-top top-0 bg-sidebar-1">
                    <div className="d-flex flex-wrap justify-content-between pt-2 px-3">
                        <Link to="" className="col-auto d-flex align-items-center mb-3 text-decoration-none text-dark" onClick={() => this.controllSideBar()}>
                            <img src={logo} className="logo" alt={"логотип"}/>
                            <span
                                className="fs-4 ps-3 text-wrap">Институт Конфуция <br/> МГУ имени А. А. Кулешова</span>
                        </Link>
                        <div className="col-auto d-flex py-3">
                            <Link to="#" className="ms-2 col-auto">
                                <i className="bi bi-x-lg fs-1 text-dark" onClick={() => this.controllSideBar()}></i>
                            </Link>
                        </div>
                    </div>
                </header>
                <div className="w-100 ps-4 pt-4">
                    {this.state.data.map((item, index) => (
                        ("data" in item) ?
                            <div className="col-12">
                                <p className="fs-1 text-wrap text-dark">
                                    {item.title}
                                </p>
                                <div className="ps-5">
                                    {(item.data !== undefined) ?
                                        item.data.map((item2, index) => (
                                            <Link className="text-decoration-none text-dark "
                                                  to={item2.link} onClick={() => this.controllSideBar()}>
                                                <p className="fs-2 text-wrap">
                                                    {item2.text}<i className="bi bi-arrow-right-short"></i>
                                                </p>
                                            </Link>
                                        )) :
                                        <></>}
                                </div>
                            </div>
                            :
                            <div className="col-12">
                                <Link to={item.link} className="text-decoration-none text-dark" onClick={() => this.controllSideBar()}>
                                    <p className="fs-1 text-wrap">
                                        {item.title}<i className="bi bi-arrow-right-short"></i>
                                    </p>
                                </Link>
                            </div>
                    ))}
                </div>
            </div>
        </>
            ;
    }
}